import { Component } from '@angular/core';
import { IzzySettingExtensionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Setting Extensions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzysettingextension-form',
    templateUrl: './izzysettingextension.form.component.html'
})
export class IzzySettingExtensionFormComponent extends BaseFormComponent {
    public record!: IzzySettingExtensionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'settingConfiguration', sectionName: 'Setting Configuration', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

